/**
 * @generated SignedSource<<9a77beef7c1059144c8cc69aa022afa4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeTxnsInputObject = {
  name?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type walletLedgerCells_AttributeMutation$variables = {
  input: AttributeTxnsInputObject;
};
export type walletLedgerCells_AttributeMutation$data = {
  readonly attributeTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type walletLedgerCells_AttributeMutation = {
  response: walletLedgerCells_AttributeMutation$data;
  variables: walletLedgerCells_AttributeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletLedgerCells_AttributeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletLedgerCells_AttributeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fdabbce9da892e2b72064e829cc2bb98",
    "id": null,
    "metadata": {},
    "name": "walletLedgerCells_AttributeMutation",
    "operationKind": "mutation",
    "text": "mutation walletLedgerCells_AttributeMutation(\n  $input: AttributeTxnsInputObject!\n) {\n  attributeTxns(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b3201de4ea57f9a6016565c79d145cb";

export default node;
